import { useState, useCallback } from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

export default function DialogCriacaoObservacaoOcorrencia({
  descriptionOptions,
  handleClose,
  data,
}) {
  const snackbar = useSnackbar();
  const [confirmando, setConfirmando] = useState(false);
  const [descricao, setDescricao] = useState("");

  const submit = useCallback(async () => {
    setConfirmando(true);

    await Api.postParams(
      "record-delivery-occurrence",
      "ordertracking",
      "?idPedido=" +
        data.NrPedido +
        "&descricao=" +
        descricao.value +
        "&sistema=PORTALB2B",
      true
    )
      .then((res) => {
        data.OcorrenciaEntrega = res.Result.Descricao;

        snackbar.showMessage(
          `Registro de ocorrência do pedido ${data.NrPedido} realizado com sucesso!`,
          {
            severity: "success",
          }
        );
        handleClose();
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(
          "Ocorreu um erro ao registrar ocorrência do pedido. Verifique os parâmetros informados.",
          {
            severity: "error",
          }
        );      })
      .finally(() => setConfirmando(false));
  }, [data, descricao, snackbar, handleClose]);

  return (
    <Dialog
      open
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Registrar ocorrência do pedido {data.NrPedido}
          </Typography>
        </span>
      </DialogTitle>
      <DialogContent
        style={{ overflowY: "hidden", padding: "0 1.5rem 1.5rem" }}
      >
        <Typography id="alert-dialog-description" variant="h4">
          Preencha a descrição da ocorrência do pedido
        </Typography>
        <br />
        <FormGroup>
          <AutoCompleteField
            label="Observação"
            onChange={(value) => {
              if (value !== "all") {
                setDescricao(value);
              } else {
                setDescricao("");
              }
            }}
            value={descricao}
            options={descriptionOptions}
            disabled={confirmando}
            optionLabelKey="descricao"
            customTooltipText={(option) =>
              typeof option === "object" ? `${option.observacao}` : ""
            }
          />
        </FormGroup>
        {confirmando && (
          <div>
            <span>Registrando ocorrência...</span>
            <LinearProgress />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button component={Box} onClick={handleClose} disabled={confirmando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={submit}
          disabled={confirmando || MaskAndValid.isNullOrEmpty(descricao)}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
